import React, { useState } from "react";
import { Box, Button } from '@mui/material';
import PageHeader from "../../../components/PageHeader";
import StyledDataGrid from "../../../components/StyledDataGrid";
import WorkspacePage from "../../../components/WorkspacePage";

const BioBankDonorChain = () => {
  const [rows] = useState([
    {
      id: 1,
      donorID: "D001",
      bioSpecimenID: "B001",
      patientName: "John Doe",
      gender: "Male",
      birthDate: "1985-06-15",
      ethnicity: "Caucasian",
      healthStatus: "Healthy",
      medicalHistory: "None",
      familyHistory: "Heart Disease",
      lifeStyle: "Non-Smoker",
      city: "New York",
      zipCode: "10001",
      irbNum: "IRB123",
      consentStatus: "Active",
    },
    {
      id: 2,
      donorID: "D002",
      bioSpecimenID: "B002",
      patientName: "Jane Smith",
      gender: "Female",
      birthDate: "1990-08-22",
      ethnicity: "Asian",
      healthStatus: "Diabetic",
      medicalHistory: "Diabetes Type 2",
      familyHistory: "None",
      lifeStyle: "Smoker",
      city: "Los Angeles",
      zipCode: "90001",
      irbNum: "IRB456",
      consentStatus: "Active",
    },
  ]);

  const columns = [
    { field: "donorID", headerName: "Donor ID", flex: 1 },
    { field: "bioSpecimenID", headerName: "BioSpecimen ID", flex: 1 },
    { field: "patientName", headerName: "Participant Name", flex: 1 },
    { field: "gender", headerName: "Gender", flex: 1 },
    { field: "birthDate", headerName: "Birth Date", flex: 1 },
    { field: "ethnicity", headerName: "Ethnicity", flex: 1 },
    { field: "healthStatus", headerName: "Health Status", flex: 1 },
    { field: "medicalHistory", headerName: "Medical History", flex: 1 },
    { field: "familyHistory", headerName: "Family History", flex: 1 },
    { field: "lifeStyle", headerName: "Life Style", flex: 1 },
    { field: "city", headerName: "City", flex: 1 },
    { field: "zipCode", headerName: "Zip Code", flex: 1 },
    { field: "irbNum", headerName: "IRB Number", flex: 1 },
    { field: "consentStatus", headerName: "Consent Status", flex: 1 },
  ];

  const shouldPaginate = rows.length > 5;

  return (
    <WorkspacePage>
      <PageHeader
        title="BioBank Donor Chain"
        actions={<Button variant="outlined">Add Data</Button>}
      />
      <Box sx={{ flex: 1, minHeight: 0, width: "100%", overflowX: "auto" }}>
        <StyledDataGrid
          rows={rows}
          columns={columns}
          pageSizeOptions={[10, 25, 50, 100]}
          pagination={shouldPaginate}
          autoHeight
          disableSelectionOnClick
          sx={{
            "& .MuiDataGrid-columnHeaders": { backgroundColor: "#f5f5f5" },
          }}
        />
      </Box>
    </WorkspacePage>
  );
};

export default BioBankDonorChain;
